import React from "react";

const SearchPlus = ({ style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="30.914"
      height="31.739"
      viewBox="0 0 30.914 31.739"
    >
      <g id="Raggruppa_1138" transform="translate(-57.807 -459.791)">
        <path
          id="Tracciato_115"
          d="M73.214,469.538h-3.66v-3.659a1,1,0,0,0-2,0v3.659H63.9a1,1,0,1,0,0,2h3.658v3.66a1,1,0,0,0,2,0v-3.66h3.66a1,1,0,0,0,0-2Z"
        />
        <path
          id="Tracciato_116"
          d="M88.135,488.116l-7.676-7.675a1.984,1.984,0,0,0-1.924-.511l-2.1-2.1a10.791,10.791,0,1,0-1.491,1.337l2.179,2.179a1.994,1.994,0,0,0,.511,1.926l7.675,7.676a2,2,0,0,0,2.829-2.829ZM59.807,470.539A8.748,8.748,0,1,1,74.435,477a.95.95,0,0,0-.148.1.888.888,0,0,0-.06.091,8.738,8.738,0,0,1-14.42-6.648Z"
        />
      </g>
    </svg>
  );
};

export default SearchPlus;
